<template>
  <v-layout row wrap class="pt-4">
    <v-flex xs8 offset-xs2>
      <v-card>
        <v-card-title class="justify-center" primary-title>
          <h3 class="headline mb-0">Настройка отчета</h3>
        </v-card-title>

        <v-card-text>
          <v-form v-model="formValidation" ref="form" validation>
            <v-layout row wrap>
              <v-flex xs4 sm4 md4 class="pr-3">
                <v-select
                  v-model="params.reportId"
                  :items="reports"
                  item-text="name"
                  item-value="reportId"
                  label="Тип отчета"
                  :rules="[reportRequire]"
                ></v-select>
              </v-flex>
            </v-layout>

            <v-layout row wrap v-if="params.reportId">
              <v-flex xs2 sm2 md2 class="pr-3">
                <v-dialog
                  ref="dateFrom"
                  v-model="dateFromModal"
                  :return-value.sync="params.dateFrom"
                  persistent
                  lazy
                  full-width
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :rules="[dateFromRequire]"
                      v-model="params.dateFrom"
                      label="Дата от"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="params.dateFrom" scrollable locale="ru-ru">
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="dateFromModal = false">Отмена</v-btn>
                    <v-btn flat color="primary" @click="$refs.dateFrom.save(params.dateFrom)">Подтвердить</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>
              <v-flex xs2 sm2 md2 class="pr-3">
                <v-text-field
                  :rules="[timeFromRequire]"
                  v-model="params.timeFrom"
                  label="Время от">
                </v-text-field>
              </v-flex>

              <v-flex xs2 sm2 md2 class="pr-3">
                <v-dialog
                  ref="dateTo"
                  v-model="dateToModal"
                  :return-value.sync="params.dateTo"
                  persistent
                  lazy
                  full-width
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :rules="[dateToRequire]"
                      v-model="params.dateTo"
                      label="Дата до"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="params.dateTo" scrollable locale="ru-ru">
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="dateToModal = false">Отмена</v-btn>
                    <v-btn flat color="primary" @click="$refs.dateTo.save(params.dateTo)">Подтвердить</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>
              <v-flex xs2 sm2 md2 class="pr-3">
                <v-text-field
                  :rules="[timeToRequire]"
                  v-model="params.timeTo"
                  label="Время до">
                </v-text-field>
              </v-flex>

              <v-flex
                xs2 sm2 md2
                class="pr-3"
                v-if="params.reportId !== '1' && params.reportId !== '2'"
              >
                <v-text-field
                  :rules="[lateTimeRequire]"
                  v-model="params.lateTime"
                  label="Время опаздания с">
                </v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row wrap v-if="params.reportId === '9999999'">
              <v-flex xs5 sm5 md5>
                <v-autocomplete
                  :rules="[employeeRequire]"
                  :no-data-text="'Ничего не найдено.'"
                  :items="employees"
                  item-text="name"
                  item-value="id"
                  v-model="params.employeeId"
                  label="Сотрудник"
                >
                </v-autocomplete>
              </v-flex>
            </v-layout>

            <v-layout row wrap v-if="params.reportId === '2' || params.reportId === '4'">
              <v-flex xs5 sm5 md5>
                <v-autocomplete
                  :rules="[departmentRequire]"
                  :no-data-text="'Ничего не найдено.'"
                  :items="departments"
                  item-text="name"
                  item-value="id"
                  v-model="params.departmentId"
                  label="Отдел"
                >
                </v-autocomplete>
              </v-flex>
            </v-layout>
          </v-form>

        </v-card-text>
        <v-card-actions>
          <v-btn
            flat color="orange"
            :disabled=" !formValidation || loading"
            :loading="loading"
            @click="getReportData()"
          >
            Получить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  export default {
    data() {
      return {
        dateFromModal: false,
        dateToModal: false,
        params: {
          dateFrom: '',
          timeFrom: '00:00',
          dateTo: '',
          timeTo: '23:59',
          lateTime: '08:25',
          employeeId: '',
          departmentId: '',
        },
        reports: [
          {reportId: '1', name: 'Все события'},
          {reportId: '2', name: 'Все события по отделу'},
          {reportId: '3', name: 'Опоздания по всем сотрудникам'},
          {reportId: '4', name: 'Опоздания сотрудников по отделам'},
        ],
        reportId: '',
        formValidation: false,
        reportRequire: value => !!value || 'Тип отчета не выбран.',
        dateFromRequire: value => !!value || 'Дата не выбрана.',
        timeFromRequire: value => !!value || 'Время не указано.',
        dateToRequire: value => !!value || 'Дата не выбрана.',
        timeToRequire: value => !!value || 'Время не указано.',
        lateTimeRequire: value => !!value || 'Время не указано.',
        employeeRequire: value => !!value || 'Сотрудник не выбран.',
        departmentRequire: value => !!value || 'Отдел не выбран.'
      }
    },
    methods: {
      async getReportData() {
        await this.$store.dispatch('fetchReportData', this.params)
      }
    },
    computed: {
      employees() {
        return this.$store.getters.employees.map(employee => {
          return {
            id: employee.id,
            name: employee.employee_name
          }
        })
      },
      departments() {
        return this.$store.getters.departments.map(department => {
          return {
            id: department.id,
            name: department.name
          }
        })
      },
      loading() {
        return this.$store.getters.loading
      }
    }
  }
</script>
